import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-tableau-dashboard',
    templateUrl: './tableau-dashboard.component.html',
    styleUrls: ['./tableau-dashboard.component.scss'],
    standalone: false
})
export class TableauDashboardComponent implements OnInit {

  shouldDisplay = environment.enableTableau;

  constructor() { }

  ngOnInit(): void {
  }
}
